import { FormConfig, FormValues, NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { getValueOrDefault } from '../components/values/Get';

export const getNextPage: NextFunction = async (curPageId: string, formConfig: FormConfig, formValues: FormValues) => {
    let nextPage: string | undefined = '';

    switch (curPageId) {
        // Step 0: Landing page
        case 'godt-at-vide':
            nextPage = 'dato';
            break;

        // Step 1: About the damage
        case 'dato':
            nextPage = 'adresse';
            break;
        case 'adresse':
            nextPage = 'beskriv-haendelsen';
            break;
        case 'beskriv-haendelsen':
            nextPage = 'koeretoej-nummerplade';
            break;

        case 'koeretoej-nummerplade':
            nextPage = 'om-koeretoejet';
            break;
        case 'om-koeretoejet':
            const isVehicleTypeOtherSelected =
                getValueOrDefault(formConfig, formValues, 'vehicleTypeOther').value === 'other';

            // If a customer has selected 'other' as vehicle type -> skip the skadezone page
            nextPage = isVehicleTypeOtherSelected ? 'skader-andet-koeretoej' : 'skadezone';
            break;
        case 'skadezone':
            nextPage = 'dokumentation';
            break;
        case 'skader-andet-koeretoej':
            nextPage = 'dokumentation';
            break;

        case 'dokumentation':
            nextPage = 'forsikringsmaegler';
            break;
        case 'forsikringsmaegler':
            nextPage = 'om-virksomheden';
            break;

        case 'om-virksomheden':
            nextPage = 'andet-selskab';
            break;

        case 'andet-selskab':
            if (getValueOrDefault(formConfig, formValues, 'duplicateInsuranceInOtherCompany').value === 'Yes') {
                nextPage = 'hvilket-selskab';
            } else {
                nextPage = 'om-dig';
            }
            break;

        case 'hvilket-selskab':
            nextPage = 'om-dig';
            break;

        case 'om-dig':
            nextPage = 'resume';
            break;
        case 'resume':
            nextPage = undefined;
            break;
        default:
            console.log('# curPageId=', curPageId);
            throw new Error('Unknown page: ' + curPageId);
    }

    return nextPage;
};
